module.exports = __webpack_public_path__ + "img/regular_cycle_2.09f12432.jpg";